<template>
  <v-layout row wrap pa-3>
    <v-flex xs12 wrap>
      <v-layout row wrap main-section>
        <v-flex xs12 pt-3>
          <v-card-title>
            <!-- <h3 class="halfwhite-text">
                {{ $store.getters.getHeadingForBalanceBlock }}
              </h3> -->
            <v-icon>mdi-email-outline</v-icon>
            <h4 class="headline halfwhite-text ml-2">Email Templates</h4>
          </v-card-title>
          <v-flex mx-2>
            <v-progress-linear
              v-if="loading"
              color="#d13b55"
              height="2"
              indeterminate
            ></v-progress-linear>
            <v-container fluid grid-list-lg>
              <v-layout row wrap>
                <v-flex
                  xs12
                  sm6
                  md3
                  v-for="(et, etIndex) in emailTemplates"
                  :key="etIndex"
                >
                  <v-card class="rounded">
                    <div class="email-template-preview" v-html="et.body"></div>
                    <v-card-actions class="blue-bg">
                      <span class="white--text font-weight-medium">{{
                        et.title
                      }}</span>
                      <v-spacer></v-spacer>
                      <v-btn
                        @click.stop="editTemplate(et)"
                        :disabled="loading"
                        icon
                      >
                        <v-icon title="Edit" color="#ffffff">mdi-pencil</v-icon>
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-flex>
              </v-layout>
            </v-container>
          </v-flex>
          <!-- <v-flex xs12 mx-3 mt-4>
            <v-card class="rounded">
              <v-card-text>
                <div>
                  <v-data-table
                    :headers="headers"
                    :items="emailTemplates"
                    :loading="loading"
                    item-key="key"
                    sort-by="title"
                    hide-actions
                    class="elevation-1"
                  >
                    <template v-slot:progress>
                      <v-progress-linear
                        color="#d13b55"
                        height="2"
                        indeterminate
                      ></v-progress-linear>
                    </template>
                    <template v-slot:items="props">
                      <td class="font-weight-bold">
                        {{ props.item.title }}
                      </td>
                      <td>
                        {{ props.item.subject }}
                      </td>
                      <td>
                        <div>{{ props.item.availableTokens }}</div>
                        <div
                          style="height: 200px; overflow: auto"
                          v-html="props.item.body"
                        ></div>
                      </td>
                      <td>
                        <v-btn
                          icon
                          @click.stop="editTemplate(props.item)"
                          :disabled="loading"
                        >
                          <v-icon title="Edit" size="24" color="#d13b55"
                            >mdi-file-document-edit</v-icon
                          >
                        </v-btn>
                      </td>
                    </template>
                  </v-data-table>
                </div>
              </v-card-text>
            </v-card>
          </v-flex> -->
          <v-flex v-if="editMode" xs12 mx-4 mt-4>
            <v-card class="rounded">
              <v-card-text>
                <v-flex>
                  <v-layout row wrap>
                    <v-flex xs12 md7>
                      <v-form
                        ref="emailForm"
                        v-model="formValid"
                        v-on:submit.prevent="saveTemplate"
                      >
                        <!-- <v-text-field
                            class="mb-3"
                            v-model="editedItem.title"
                            label="Title"
                            :rules="requiredRules"
                            hint="Template Title (used to describe template)"
                            persistent-hint
                          ></v-text-field>

                          <v-text-field
                            class="mb-3"
                            v-model="editedItem.subject"
                            label="Subject"
                            :rules="emailSubjectRules"
                            hint="Email Subject (100 chars max)"
                            persistent-hint
                          ></v-text-field> -->

                        <div class="mb-3">
                          <label for="tokens"
                            >Available Tokens
                            <span class="caption"
                              >(You can use them in Email Body, App will replace
                              it with actual values while sending)</span
                            ></label
                          >
                          <p id="tokens" class="caption font-weight-bold">
                            {{ editedItem.availableTokens }}
                          </p>
                        </div>

                        <div class="mb-3">
                          <label for="emailBody">Email Body</label>
                          <vue-editor
                            id="emailBody"
                            class="rounded"
                            v-model="emailContent"
                            placeholder="Enter email body..."
                            :editorOptions="editorSettings"
                          />
                        </div>

                        <div class="mb-2">
                          <v-btn
                            class="btn-rounded-medium"
                            outline
                            color="#d13b55"
                            @click.prevent="saveTemplate"
                            :disabled="!formValid || loading"
                          >
                            Save
                          </v-btn>
                          <span class="px-2"></span>
                          <v-btn
                            class="btn-rounded-medium"
                            outline
                            color="secondary"
                            @click.prevent="cancelSaveTemplate"
                          >
                            Cancel
                          </v-btn>
                        </div>
                      </v-form>
                    </v-flex>
                    <v-flex xs12 md5 px-4>
                      <div class="title font-weight-regular mb-2">
                        Email Preview
                        <span class="caption font-weight-bold"
                          >({{ editedItem.title }})</span
                        >
                      </div>
                      <v-card class="rounded" style="background-color: #fff">
                        <v-card-text>
                          <div
                            style="height: 785px; overflow: auto"
                            v-html="emailContent"
                          ></div>
                        </v-card-text>
                      </v-card>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-flex>
      </v-layout>
    </v-flex>
  </v-layout>
</template>

<script>
import axios from "axios";
import validationRules from "@/js/validationRules.js";

import { VueEditor, Quill } from "vue2-editor";
window.Quill = Quill;
const ImageResize = require("quill-image-resize-module").default;
Quill.register("modules/imageResize", ImageResize);

export default {
  name: "EmailTemplatesView",
  components: { VueEditor },
  data() {
    return {
      formValid: true,
      loading: false,
      emailTemplates: [],
      editedItem: {},
      emailContent: "",
      editMode: false,
      editorSettings: {
        modules: {
          imageResize: {},
          toolbar: {
            container: [
              [{ header: [1, 2, 3, 4, 5, 6, false] }],
              ["bold", "italic", "underline", "strike"],
              ["blockquote", "code-block"],
              [{ list: "ordered" }, { list: "bullet" }],
              [{ script: "sub" }, { script: "super" }],
              [{ indent: "-1" }, { indent: "+1" }],
              [{ direction: "rtl" }],
              [{ color: [] }, { background: [] }],
              [{ font: [] }],
              [{ align: [] }],
              ["link", "image", "video"],
              ["clean"],
            ],
            handlers: {
              image: function () {
                var cursorLocation = this.quill.getSelection();
                var emailImageUrl = prompt("please enter the image url here.");
                if (emailImageUrl) {
                  this.quill.insertEmbed(
                    cursorLocation.index,
                    "image",
                    emailImageUrl,
                    Quill.sources.USER
                  );
                }
              },
            },
          },
        },
      },
      emailSubjectRules: validationRules.emailSubjectRules,
      requiredRules: validationRules.requiredRules,
    };
  },
  methods: {
    getEmailTemplates: function () {
      if (
        (this.$store.getters.userIsAdministrativeOrOrgOwner ||
          this.$store.getters.isHRManager) &&
        this.$store.getters.isCurrentOrgSet &&
        !this.$store.getters.isCurrentOrgChild
      ) {
        this.loading = true;
        const urlPart = this.$store.getters.isSuperAdmin ? 0 : 1;
        axios
          .get(
            "/api/org/email/templates/" +
              this.$store.getters.getOrgIdentifier +
              "/" +
              urlPart,
            this.$store.state.axiosConfig
          )
          .then((response) => {
            this.emailTemplates = response.data;
            this.loading = false;
          })
          .catch((e) => {
            console.error(e);
            this.loading = false;
          });
      }
    },
    editTemplate: function (itemToEdit) {
      this.editedItem = Object.assign({}, itemToEdit);
      this.emailContent = this.editedItem.body;
      this.editMode = true;
    },
    saveTemplate: function () {
      // Disable form submission while async call takes place
      this.formValid = false;
      this.loading = true;

      // Display Message
      this.$store.commit("replaceSnackbar", {
        message: "Saving Email Template...",
        messageType: "warning",
      });

      this.editedItem.body = this.emailContent; // Set the body
      const params = this.editedItem;

      axios
        .post(
          "/api/org/email/template/" + this.$store.getters.getOrgIdentifier,
          params,
          this.$store.state.axiosConfig
        )
        .then((response) => {
          // Allow form submission
          this.formValid = true;
          this.loading = false;

          // Display Success message
          this.$store.commit("replaceSnackbar", {
            message: "Email Template has been saved successfully.",
          });

          this.cancelSaveTemplate(); // Reset the form
          this.getEmailTemplates(); // Refresh list
        })
        .catch((e) => {
          // Allow form submission
          this.formValid = true;
          this.loading = false;

          // check/ handle 401 (Unauthorized) error
          this.$store.dispatch("error401Response", e);

          // Display Error Message
          this.$store.commit("replaceSnackbar", {
            message:
              "Error. Saving Email Template.<br><strong>" +
              e.response.data.message +
              "</strong>",
            messageType: "error",
          });
        });
    },
    cancelSaveTemplate: function () {
      this.editMode = false;
      this.emailContent = "";
      this.editedItem = {};

      this.$refs.emailForm.reset();
    },
  },
  beforeMount() {
    this.getEmailTemplates();
  },
};
</script>